import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import TextBox from "devextreme-react/text-box";
import PivotGrid, { FieldChooser, Export } from "devextreme-react/pivot-grid";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source"; //??
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportPivotGrid } from "devextreme/excel_exporter";
import useSWR from "swr";
import Input from "../../Components/Input";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import ErrorRange from "../../Components/ErrorRange";
import ActionNotifications from "../../Components/ActionNotifications";

import "./styles.css";

export default function UsersReportPage() {
  const getFullWeeksStartAndEndInMonth = (month, year) => {
    let weeks = [],
      firstDate = new Date(year, month, 1),
      lastDate = new Date(year, month + 1, 0),
      numDays = lastDate.getDate();

    let start = 1;
    let end;
    if (firstDate.getDay() === 1) {
      end = 7;
    } else if (firstDate.getDay() === 0) {
      let preMonthEndDay = new Date(year, month, 0);
      start = preMonthEndDay.getDate() - 6 + 1;
      end = 1;
    } else {
      let preMonthEndDay = new Date(year, month, 0);
      start = preMonthEndDay.getDate() + 1 - firstDate.getDay() + 1;
      end = 7 - firstDate.getDay() + 1;
      weeks.push({
        start: start,
        end: end,
      });
      start = end + 1;
      end = end + 7;
    }
    while (start <= numDays) {
      weeks.push({
        start: start,
        end: end,
      });
      start = end + 1;
      end = end + 7;
      end = start === 1 && end === 8 ? 1 : end;
      if (end > numDays && start <= numDays) {
        end = end - numDays;
        weeks.push({
          start: start,
          end: end,
        });
        break;
      }
    }
    // *** the magic starts here
    return weeks.map(({ start, end }, index) => {
      const sub = +(start > end && index === 0);
      return Array.from({ length: 7 }, (_, index) => {
        const date = new Date(year, month - sub, start + index);
        const dateStr = date.toISOString();

        return {
          date: date.getDate(),
          month: date.toLocaleString("en", { month: "short" }),
          day: date.toLocaleString("en", { weekday: "short" }),
          fullDate: dateStr.slice(0, dateStr.indexOf("T")),
        };
      });
    });
  };

  const dateobj = new Date();

  const findIndex = () => {
    let index = null;
    const arr = getFullWeeksStartAndEndInMonth(
      dateobj.getMonth(),
      dateobj.getFullYear()
    );

    for (let i = 0; i < arr.length; i++) {
      arr[i].map((y) => {
        if (
          y.date === dateobj.getDate() &&
          y.month === dateobj.toLocaleString("en", { month: "short" })
        ) {
          index = i;
        }
      });
    }

    return index;
  };

  const date = dateobj.toISOString(),
    [state, setState] = useState({
      showSpinner: false,
      showDateInput: false,
      date: date.slice(0, date.indexOf("T")),
      index: findIndex(),
      dateOpt: getFullWeeksStartAndEndInMonth(
        dateobj.getMonth(),
        dateobj.getFullYear()
      ),
      allUsers: [],
      filteredUsers: [],
      users: [],
      dates: [],
      notifications: [],
      projectsList: [],
      searchOptValue: "",
    }),
    { data, mutate, error } = useSWR(
      `${apiBaseURL}/api/Reports/UserReportsForDays`,
      { refreshInterval: 600000 }
    );

  const onInputChange = async (e) => {
    const { name, value } = e.target,
      inputNameError = `${name}Error`;
    let stateValues = { ...state };
    console.log(e);
    stateValues = { ...stateValues, [name]: value };

    if (name !== "") {
      stateValues = { ...stateValues, [inputNameError]: false };
    }

    setState(stateValues);
    mutate();
  };

  const DateFormatter = (date) => {
    const dateArray = date.split("-");
    const year = dateArray[0];
    const month = parseInt(dateArray[1], 10) - 1;
    const day = dateArray[2];

    return new Date(year, month, day).toLocaleDateString();
  };

  const dateCarousel = () => {
    if (state.showDateInput || state.dateOpt.length < 1) {
      return (
        <div className="row">
          <Input
            name="date"
            onChange={onInputChange}
            value={state.date}
            labelTitle="Date"
            type="date"
            noMarginB
          />
          <div className="row mt-3">
            <h6
              className="text-end mb-0 hoverLinkText yellow fw-normal pointer"
              onClick={() => setState({ ...state, showDateInput: false })}
            >
              Show date slider
            </h6>
          </div>
        </div>
      );
    } else {
      const d = new Date();
      return (
        <div className="row">
          <div className="row">
            {state.index - 1 >= 0 ? (
              <div
                className="col-1 text-center p-4"
                onClick={() => setState({ ...state, index: state.index - 1 })}
              >
                <div className="arrowDateCard">
                  <div className="dashPillLogoWrapper flexBoxCCC">
                    <FontAwesomeIcon
                      className="pointer"
                      icon={faArrowLeft}
                      size="2x"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-1" />
            )}
            <div className="col-10 gx-5">
              <div className="row gx-5">
                {state.dateOpt.length > 0 &&
                  state.dateOpt[state.index].map((date, i) => {
                    const active =
                      state.date === date.fullDate ? "activeCard" : "";
                    return (
                      <div
                        key={i}
                        className={`col dateCard border-2-solid-ltGray mx-2 p-4 ${active}`}
                        onClick={() =>
                          setState({ ...state, date: date.fullDate })
                        }
                      >
                        <div className="row">
                          <h6 className="gray">
                            {date.month} {d.getFullYear()}
                          </h6>
                        </div>
                        <div className="row">
                          <h6 className="gray fw-normal">{date.day}</h6>
                        </div>
                        <div className="row">
                          <h5>{date.date}</h5>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {state.index + 1 < state.dateOpt.length ? (
              <div
                className="col-1 text-center p-4"
                onClick={() => setState({ ...state, index: state.index + 1 })}
              >
                <div className="arrowDateCard">
                  <div className="dashPillLogoWrapper flexBoxCCC">
                    <FontAwesomeIcon
                      className="pointer"
                      icon={faArrowRight}
                      size="2x"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-1" />
            )}
          </div>
          <div className="row mt-3">
            <h6
              className="text-end mb-0 hoverLinkText yellow fw-normal pointer"
              onClick={() => setState({ ...state, showDateInput: true })}
            >
              Enter date manually
            </h6>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (data) {
      const dates = data.data.map((x) =>
        new Date(x.date).toLocaleDateString("en-US")
      );
      const users = data.data.map((x) => ({
        date: new Date(x.date).toLocaleDateString("en-US"),
        name: `${x.firstName} ${x.lastName}`,
        //workCenter: x.workCenter,
        hours: x.hours,
        supervisor: x.supervisor,
      }));
      setState({ ...state, users, dates });
    }
  }, [data]);

  const onExporting = React.useCallback((e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("User_Hour_Report");

    exportPivotGrid({
      component: e.component,
      worksheet,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "User_Hour_Report.xlsx"
        );
      });
    });
    e.cancel = true;
  });

  const dataSource = new PivotGridDataSource({
    fields: [
      /*{
            dataField: 'workCenter',
            width: 150,
            expanded: true,
            area: 'row'
        },*/ {
        dataField: "supervisor",
        width: 150,
        expanded: true,
        area: "row",
      },
      {
        dataField: "name",
        width: 150,
        expanded: true,
        area: "row",
      },
      {
        dataField: "date",
        area: "column",
        selector(data) {
          let date = new Date(data.date);
          let year = date.getFullYear();
          let month = (1 + date.getMonth()).toString().padStart(2, "0");
          let day = date.getDate().toString().padStart(2, "0");

          return month + "/" + day + "/" + year;
        },
      },
      {
        dataField: "hours",
        dataType: "number",
        expanded: true,
        summaryType: "sum",
        area: "data",
      },
    ],
    store: state.users,
  });

  const renderResults = () => {
    if (!data && !error) {
      return (
        <div className="col text-center">
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" size="5x" />
        </div>
      );
    } else if (data?.statusCode) {
      const onCellClick = (e) => {
        e.cancel = true;
      };

      const cellRender = (e) => {
        //does this round properly?
        if (e.columnIndex === 1) {
          return data
            ? Math.round((e.row.data.hours + Number.EPSILON) * 100) / 100 +
                " hrs"
            : null;
        } else if (e.columnIndex === 0) {
          const date = new Date(e.value).toLocaleDateString("en-US");
          return date;
        }
      };

      const onCellPrepared = (e) => {
        console.log(e);
        if (e.area == "row") {
          if (e.rowIndex % 2 == 0) {
            e.cellElement.css("background-color", "lightblue");
          }
        }
      };

      //const onContentReady = (e) => {
      //    console.log(e)
      //    //const name = state.users.name.map((x) => ({ dataField: x, dataType: 'string', caption: 'Name' }))
      //    //let newColumnsArray = e.component.option("columns", state.users.name);
      //    const newColumnsArray = state.dates.map((x) =>
      //    ({
      //        dataField: x,
      //        dataType: 'date',
      //        caption: x
      //    }))
      //    console.log(newColumnsArray)
      //    e.component.option("columns", newColumnsArray);
      //}

      const onHandleSearch = (e) => {
        console.log(e);
        //state.filteredUsers.push(e.event.originalEvent.key)
        //console.log(state.filteredUsers)
        //dataSource.filter('name', 'contains', e.event.originalEvent.key);
        //console.log(dataSource)
        //dataSource.reload();

        const { value } = e.target;
        let allUsers = data.data.map((x) => ({
          date: new Date(x.date).toLocaleDateString("en-US"),
          firstName: x.firstName,
          lastName: x.lastName,
          hours: x.hours,
          supervisor: x.supervisor,
        }));

        const filteredData = allUsers.filter((opt) => {
          console.log(opt);
          //const supervisor = opt.supervisor ? opt.supervisor.toLowerCase() : null;
          //return supervisor !== null ? supervisor.includes(value.toLowerCase()) : null;
          const name = `${opt.firstName.toLowerCase()} ${opt.lastName.toLowerCase()}`;
          return name.includes(value.toLowerCase());
        });

        if (value === "") {
          const users = data.data.map((x) => ({
            date: new Date(x.date).toLocaleDateString("en-US"),
            name: `${x.firstName} ${x.lastName}`,
            hours: x.hours,
            supervisor: x.supervisor,
          }));
          setState({ ...state, users, searchOptValue: value });
        } else {
          let filter = filteredData.map((x) => ({
            date: new Date(x.date).toLocaleDateString("en-US"),
            name: `${x.firstName} ${x.lastName}`,
            hours: x.hours,
            supervisor: x.supervisor,
          }));
          setState({ ...state, users: filter, searchOptValue: value });
        }
      };

      return (
        <div className="row">
          {/*<TextBox className="col-auto" id="search" placeholder="Search..." showClearButton={true} onInput={onHandleSearch} />*/}
          <div className="row g-0">
            <input
              type="search"
              placeholder="Search..."
              className="col-4 mb-3 form-control"
              onChange={onHandleSearch}
              value={state.searchOptValue}
            />
          </div>
          {/*<TextBox*/}
          {/*    style={{ marginBottom: '10px' }}*/}
          {/*    placeholder="Search..."*/}
          {/*    onValueChanged={onHandleSearch}*/}
          {/*/>*/}
          <div className="row g-0 ">
            <PivotGrid
              id="pivotgrid"
              dataSource={dataSource}
              height="65vh"
              //rowHeaderLayout="tree"
              //allowSortingBySummary={true}
              //allowFiltering={true}
              showBorders={true}
              showColumnTotals={false}
              showColumnGrandTotals={false}
              showRowTotals={false}
              showRowGrandTotals={false}
              onExporting={onExporting}
              onCellPrepared={(e) => {
                if (e.cell) {
                  e.cellElement.style.backgroundColor = "rgba(85, 85, 85, 0.5)";
                  e.cellElement.style.border =
                    "1px solid rgba(255, 255, 255, 0.3)";
                  e.cellElement.style.color = "white"; // optional for better text contrast
                }
              }}
            >
              <FieldChooser enabled={false} />
              <Export enabled={true} />
            </PivotGrid>
          </div>
        </div>
      );

      return (
        <h5 className="text-center mb-0">
          There are no engineering hours within the time period selected to
          generate a report. Try again by selecting a different date.
        </h5>
      );
    } else if (!data.statusCode) {
      console.log(2);
      return (
        <>
          <h3 className="red">
            <u>Error{data.messeges.length > 1 && "s"}</u>
          </h3>
          <ul className="mb-0" style={{ listStyleType: "circle" }}>
            {data.messeges.map((msg) => {
              return (
                <li className="red">
                  <h5 className="mb-0">{msg}</h5>
                </li>
              );
            })}
          </ul>
        </>
      );
    }
  };

  return (
    <div className="px-lg-3 page-content">
      <ActionNotifications arrayOfToasts={state.notifications} />
      <div className="px-2">
        <div className="container-fluid g-0">
          <div className="contentBox p-5">
            <div className="row">
              <h1 className="white">Engineering Hours Report</h1>
            </div>
            {!error ? renderResults() : <ErrorRange />}
          </div>
        </div>
      </div>
    </div>
  );
}
